import SifAuAdapter from './base';

export default class Connection extends SifAuAdapter {
  modelNamePlural = 'connections';
}
